<template>
  <Paginator
    v-bind="properties"
    @change-page="changePage"
    @next-page="nextPage"
    @prev-page="prevPage"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Paginator from '@/components/Common/Paginator';

export default {
  components: {
    Paginator
  },
  props: {
    defaultSort: {
      type: String,
      required: false,
      default: ''
    },
    forceExperience: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    ...mapState('search', ['currentPage', 'totalPages']),
    ...mapState('searchBar', ['actualSearch']),
    ...mapGetters('experience', ['getExperience']),
    ...mapGetters('dimensions', [
      'getActualDimensionName',
      'getDimensionByName',
      'getActualDimension',
      'getPaginationDimension'
    ]),
    ...mapGetters('search', ['getQuery']),
    inGraphicsDimension() {
      return this.getActualDimension.path == 'graphics';
    },
    nextPageLink() {
      const dimName = this.getPaginationDimension
        ? this.getPaginationDimension
        : this.getActualDimensionName;

      return this.$urlBuilder('search', {
        path: this.getDimensionByName(dimName, this.getExperience, false).path,
        keyword: this.actualSearch,
        page: this.currentPage + 1,
        query: this.query
      });
    },
    prevPageLink() {
      const dimName = this.getPaginationDimension
        ? this.getPaginationDimension
        : this.getActualDimensionName;

      return this.$urlBuilder('search', {
        path: this.getDimensionByName(dimName, this.getExperience, false).path,
        keyword: this.actualSearch,
        page: this.currentPage < 1 ? false : this.currentPage - 1,
        query: this.query
      });
    },
    properties() {
      return {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        nextPageLink: this.nextPageLink,
        prevPageLink: this.prevPageLink,
        useNuxtLink: false,
        searchPaginator: true
      };
    },
    searchDimension() {
      return this.getPaginationDimension
        ? this.getPaginationDimension
        : this.getActualDimensionName;
    },
    query() {
      return { ...this.$route.query, ...this.getQuery };
    }
  },
  methods: {
    changePage(page, e) {
      e.preventDefault();
      this.updateSearch(page, this.actualSearch);
    },
    nextPage(e) {
      e.preventDefault();
      this.updateSearch(this.currentPage + 1, this.actualSearch);
    },
    prevPage(e) {
      e.preventDefault();
      this.updateSearch(this.currentPage - 1, this.actualSearch);
    },
    async updateSearch(page, search) {
      const searchPromise = this.$store.dispatch('search/MAKE_SEARCH', {
        criteria: search,
        sort: this.defaultSort,
        page,
        experience: this.forceExperience
      });

      await Promise.all([searchPromise]);

      window.scrollTo(0, 0);
      const url = this.$urlBuilder('search', {
        path: this.getDimensionByName(this.searchDimension, this.getExperience, false).path,
        keyword: search,
        page
      });
      this.$store.commit('search/SET_SILENT_SEARCH', true);
      this.$router.push({ path: url, query: this.query });
    }
  }
};
</script>
